

















import { Component, Prop, PropSync, Vue, Ref } from "vue-property-decorator"

@Component
export default class AuthSecurityCode extends Vue {
  @PropSync("code", { default: "" }) securityCode!: number

  @Prop({ default: 4 }) readonly digits!: number

  @Ref() readonly codeInput!: { $refs: [] }

  allowedChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]

  handleComplete(payload) {
    this.securityCode = payload
    this.$emit("complete")
  }

  mounted() {
    this.focusCodeInput()
  }

  focusCodeInput() {
    this.codeInput.$refs["inputs"][0].$refs["inputs"].focus()
  }
}
